// detection relies on file webp-detection.js

function webpSupport() {
    const el = document.documentElement;

    if (el.classList) {
        return el.classList.contains("webp");
    }

    return el.className.includes("webp");
}

/**
 * Retrieves elements with the class "webp-inline-bg" and applies webp background images if supported.
 *
 * @return {void}
 */
export function useWebpBackgroundImages() {
    const elements = document.getElementsByClassName("webp-inline-bg");
    if (!elements.length) return;

    const isWebpSupported = webpSupport();

    for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        useWebpBackgroundImage(element, isWebpSupported);
    }
}

/**
 * Applies a webp background image to the specified HTML element if the URL is available.
 *
 * @param {HTMLElement} element - The HTML element to apply the background image to.
 * @param {boolean} isWebpSupported - Indicates whether webp format is supported.
 * @return {void}
 */
export function useWebpBackgroundImage(element: HTMLElement, isWebpSupported = webpSupport()) {
    const url = element.attributes["data-src"].value;
    if (url) {
        const webpUrl = url.replace(/\.(png|jpg|jpeg)/g, ".webp");
        const imageUrl = isWebpSupported ? webpUrl : url;
        const img = new Image();
        img.onload = () => {
            element.style.backgroundImage = `url("${imageUrl}")`;
        };
        img.onerror = () => {
            element.style.backgroundImage = `url("${url}")`;
        };
        img.src = imageUrl;
    }
}
